function send_data(data) {
  var isBoostTerminalPayment = false;
  try {
    var parsed = typeof data === "string" ? JSON.parse(data) : data;
    isBoostTerminalPayment = parsed && parsed.action === "boost_terminal_payment";
  } catch (e) {}
  if (window.ReactNativeWebView) {
    if (isBoostTerminalPayment) {
      console.log("[Boost Terminal] postMessage to app", data);
    }
    window.ReactNativeWebView.postMessage(data);
  } else if (isBoostTerminalPayment) {
    console.log("[Boost Terminal] postMessage skipped, ReactNativeWebView missing", data);
  }
}

function captureDataFromReactNativeWebView(data) {
  if (typeof data === "string") {
    try {
      data = JSON.parse(data);
    } catch (e) {
      return;
    }
  }
  if (!data || typeof data !== "object") {
    return;
  }
  if (data["action"] === "new_print_format") {
    window.getPrinterStatusReference.getPrintAcknowldegeStatus(data);
  } else if (data["action"] === "printer_status") {
    //TODO: check the name
    window.getPrinterStatusReference.updatePrinterStatus(data);
  } else if (data["queue_enabled"]) {
    window.getPrinterStatusReference.queueEnabled(data);
  } else if (data["uniqueDeviceID"]) {
    window.getPrinterStatusReference.setDeviceId(data["uniqueDeviceID"]);
  } else if (data['user_permissions']) {
    localStorage.setItem(
      'user_permissions',
      JSON.stringify(data['user_permissions'])
    );
  }
  if (data["printer_status"] === 1 || data["printer_status"] === 0) {
    window.getPrinterStatusReference.displayPrinterStatus(data);
  }
  if(data["action"] === "rnRedirection" && data['rnAppNavigateAction']) {
    window.getReactNativeRedirection.getRNAppNavigateAction(data);
  }
  if(data['action'] === "staffAuthTokenUpdate" && data['authorizationToken']) {
    localStorage.setItem('token', data['authorizationToken']);
  }
  if (data["action"] === "boost_terminal_payment_result") {
    console.log("[Boost Terminal] result from app", data);
    window.dispatchEvent(
      new CustomEvent("boostTerminalPaymentResult", { detail: data })
    );
  }
}

window.addEventListener("message", function (event) {
  captureDataFromReactNativeWebView(event.data);
});

document.addEventListener("message", function (event) {
  captureDataFromReactNativeWebView(event.data);
});
